import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Logo from '../../../assets/img/ayuda-tecnologica-online.png'

function OnlineAsistance({handleButtonClick}) {
  return (
    <Grid container spacing={0} justifyContent="center" className="texto-con-efecto">
      <Grid item xs={3} container direction="column" alignItems="flex-end" spacing={2} sx={{marginTop: '0px'}}>
        <img src={Logo} style={{ width: '50px', marginRight: '30px' }}></img>
      </Grid>
      <Grid item xs={7}container direction="column" alignItems="flex-start" spacing={2}>
        <Grid item container alignItems="left" spacing={0} sx={{paddingLeft: '0px !important' }}>
          <span style={{color: 'red', margin: '0px', paddingLeft: '0px' }}>ASISTENCIA ONLINE Y TELEFÓNICA</span>
        </Grid>
        <Typography sx={{ my: 2, textAlign: 'left', width: '100%', fontSize: '13px' }} className="texto-con-efecto">
            Solucione todas sus dudas en el día a día de sus dispositivos informáticos, Smartphones y tablets.
        </Typography>
        <Button 
            variant="contained" 
            onClick={handleButtonClick} 
            sx={{ 
              textTransform: 'none', 
              backgroundColor: 'red', 
              '&:hover': {
                backgroundColor: 'darkred',
              },
            }}
          >          
          + info
        </Button>
      </Grid>
    </Grid>
  );
}

export default OnlineAsistance;